const testimonials = [
  {
    name: "Jennifer M.",
    location: "La Grange, GA",
    rating: 5,
    text: "We planned a Caribbean cruise and realized my son's passport had expired three weeks before sailing. I was in full panic mode. Fast Passport Center sent us the exact checklist, told us exactly which clerk to visit in La Grange, and handled everything after that. We had the passport back in 8 days. Saved our family vacation.",
    service: "Child Passport",
  },
  {
    name: "Robert K.",
    location: "West Point, GA",
    rating: 5,
    text: "Business trip to Tokyo in 10 days and my passport was nowhere to be found. I called from West Point on a Monday and started the process immediately. Shipped from the UPS Store on Broad Street Tuesday morning, and my passport arrived the following Thursday. Incredible turnaround for an emergency passport.",
    service: "Emergency Passport",
  },
  {
    name: "Angela T.",
    location: "Pine Mountain, GA",
    rating: 5,
    text: "After my divorce, I needed to update my name on my passport before a work conference in London. Fast Passport Center made the name change process so straightforward. The document review caught that I had the wrong marriage decree copy — they told me exactly what to request from the Troup County Clerk. Saved me weeks.",
    service: "Name Change",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function LaGrangeTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What La Grange Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across La Grange, West Point, Pine Mountain, and west Georgia who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}